/**
 * Emits Organization + WebSite JSON-LD (schema.org) into the page <head>.
 *
 * Rendered during prerender so it ships in the static HTML for search engines and
 * AI engines (entity/knowledge understanding). No external dependency — uses Nuxt's
 * built-in useHead.
 *
 * URLs are driven by NUXT_PUBLIC_SITE_DOMAIN, so they inherit the same canonical
 * domain as the sitemap. Ensure SITE_DOMAIN is the live primary (https://www.ipolo.org)
 * for these to be correct.
 */
// Explicit #imports rather than relying on auto-import: inside a brand layer useHead
// does not resolve for `nuxi typecheck` (TS2304), which the build scripts chain on.
import { useHead } from '#imports';

export const useOrganizationSchema = () => {
   const config = useRuntimeConfig();
   const siteUrl = ((config.public.siteDomain as string) || 'https://www.ipolo.org').replace(/\/+$/, '');
   const siteName = (config.public.siteName as string) || 'International Polo';

   const graph = {
      '@context': 'https://schema.org',
      '@graph': [
         {
            '@type': 'Organization',
            '@id': `${siteUrl}/#organization`,
            name: siteName,
            url: siteUrl,
            logo: `${siteUrl}/img/ipa-logo.png`,
            sameAs: [
               'https://www.facebook.com/share/1ERMuF3yTQ/',
               'https://x.com/intlpolo',
               'https://www.instagram.com/intlpolo',
            ],
         },
         {
            '@type': 'WebSite',
            '@id': `${siteUrl}/#website`,
            name: siteName,
            url: siteUrl,
            publisher: { '@id': `${siteUrl}/#organization` },
         },
      ],
   };

   useHead({
      script: [
         {
            type: 'application/ld+json',
            innerHTML: JSON.stringify(graph),
         },
      ],
   });
};
